<template>
	<div>
		<div style="text-align:center; margin-top:20%;">
			<i class="el-icon-success" v-if="paystate=='1'" style="font-size:50pt;color:green"></i>
		</div>
		<div style="text-align:center; margin-top:20%;">
			<i class="el-icon-error" v-if="paystate=='0'" style="font-size:50pt;color:red"></i>
			<p style="font-size:12pt;">{{message}}</p>
		</div>
	</div>
</template>

<script>
import Utils from '../lib/util.js';	
export default {
		props: {},
		data() {
			return {
				pkval:'',
				ratebatch:'',
				appcode:'',
				paystate:'',
				message:''
			}
		},
		mounted() {
			//debugger
			if(this.$route.query!=undefined){
				if(this.$route.query.pkval!=undefined)
				{
					this.pkval=this.$route.query.pkval;
					this.ratebatch=this.$route.query.batch;
					this.appcode=this.$route.query.appcode;
					this.CheckPayState();
				}
				else{
					this.paystate=='0';
					this.message="支付参数加载异常，请重试";
				}
			}else{
				this.paystate=='0';
				this.message="支付参数加载异常，请重试";
			}
		},
		methods:{
			//检测支付状态
			CheckPayState(){
				var that = this;
				var paraminfo = {
					pkval: this.pkval,
					ratebatch: this.ratebatch,
					appcode:this.appcode
				}
				this.$tool.loading2('', this.divclass);
				this.$apipost.get.GetPayState({
					paraminfo: JSON.stringify(paraminfo)
				}).then(res => {
					this.$tool.loadingclose();
					//debugger
					if (res.state == '1') {
						that.paystate='1';
					} else if (res.state == '2') {
						that.paystate='2';
						that.message=res.message;
					} else {
						that.paystate='0';
						that.message=res.message;
					}
				}).catch(e => {
					that.GetPayState();
				});
				
			}
		}
	}
</script>

<style>
</style>